import { useEffect, useState } from "react";
import { Box, Button, Container, Grid, Paper, Typography, Link as MuiLink } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ImageDisplay from "../ImageDisplay";
import TextImageDisplay from "../TextImageDisplay";
import ImageCarousel from '../Carousel';
import { getDocument } from "../../firebase"; // Adjust path if needed

export const About = () => {
  const navigate = useNavigate();
  const application = useSelector(state => state.application);
  const [user, setUser] = useState({});
  const [page, setPage] = useState({ title: '', parts: [] });
  const [loadError, setLoadError] = useState(null);

  const fallbackPage = {
    title: "About Heart's Ease Cottage",
    parts: [
      {
        type: "paragraph",
        content: "Welcome to Heart's Ease Cottage — a calm, nature-led place to slow down, breathe deeply, and reconnect with what matters.",
      },
      {
        type: "paragraph",
        content: "We craft restful stays with soft light, cozy textiles, and gentle rituals inspired by the surrounding forest and garden.",
      },
    ],
  };


  useEffect(() => {
    if (application.currentUser) {
      setUser(application.currentUser);
    }

    const fetchAboutPage = async () => {
      try {
        const aboutDoc = await getDocument("pages", "about");
        if (aboutDoc) {
          setPage(aboutDoc);
          setLoadError(null);
        } else {
          setPage(fallbackPage);
        }
      } catch (err) {
        console.error("Failed to load About page", err);
        setLoadError("We couldn't load the About page right now. Showing a brief overview instead.");
        setPage(fallbackPage);
      }
    };

    fetchAboutPage();
  }, [application.currentUser]);

  const handleEditClick = () => {
    navigate("/edit-page/about");
  };

  return (
    <Container maxWidth="md">
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Typography component="h4" variant="h4">
            {page.title || "About Heart's Ease Cottage"}
          </Typography>
          
        </Grid>
        <Grid item xs={3}>
        {user.role === "admin" && (
            <Button
              variant="contained"
              color="secondary"
              onClick={handleEditClick}
              sx={{
                float: "right",
                mt: 1,
                mb: 2,
                backgroundColor: "#6a1b9a",
                "&:hover": {
                  backgroundColor: "#4a148c"
                }
              }}
            >
              Edit This Page
            </Button>
          )}
        </Grid>

        {loadError && (
          <Grid item xs={12}>
            <Paper elevation={0} sx={{ p: 2, border: '1px solid', borderColor: 'warning.light', bgcolor: 'warning.50' }}>
              <Typography variant="body2" color="warning.main">{loadError}</Typography>
            </Paper>
          </Grid>
        )}
        <Grid item xs={12}>
          <Paper elevation={4} sx={{ p: 2 }}>
            {page.parts?.map((part, index) => (
              <Box key={index} sx={{ mb: 1 }}>
                {(part.type ?? "paragraph") === "paragraph" && (
                  <Typography variant="body1">{part.content}</Typography>
                )}
                {(part.type ?? "paragraph") === "image" && (
                  <ImageDisplay part={part} />
                )}
                {(part.type ?? "paragraph") === "textImage" && (
                  <TextImageDisplay part={part} />
                )}
                {(part.type ?? "paragraph") === "carousel" && (
                  <ImageCarousel images={part.images} />
                )}
                {part.type === "bulletList" && (
                  <ul>
                    {(part.items ?? []).map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                )}
                {part.links &&
                  part.links.map((link, linkIndex) => (
                    <MuiLink
                      key={linkIndex}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{ display: "block", mt: 1 }}
                    >
                      {link.description || link.url}
                    </MuiLink>
                  ))}
              </Box>
            ))}
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Button onClick={() => navigate("/blog")} size="small" color="primary">
            View Blog
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};



